module.exports = __webpack_public_path__ + "static/media/API_Pricing.0b1ac552.png";